export const removePWAQuery: VoidFunction = () => {
  const target = new URL(window.location.href);
  target.searchParams.delete('isPWA');

  window.history.replaceState({}, document.title, target.href);
};
